import { combineReducers } from 'redux';
import loginReducer from "../Redux-slices/loginSlice.js"

const rootReducer = combineReducers({
    login:loginReducer
});

export default rootReducer;